import React from "react";
import FormButton from "./FormButton"; // Assuming the component path

const ResponsiveFormButton = ({ width, ...props }) => {
  const getButtonWidth = () => {
    const screenWidth = window.innerWidth;
    return screenWidth <= 750 ? "small" : "medium";
  };

  return <FormButton width={width || getButtonWidth()} {...props} />;
};


export default ResponsiveFormButton;
